/** @format */

import { ActivatedRoute, Router } from '@angular/router';
import { Breadcrumb, Chain } from '@shared/data-access/interfaces';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Store } from '@shared/data-access/services';

@Component({
  selector: 'shared-components-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BreadCrumbsComponent implements OnChanges, OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly chain = inject(Chain);

  public breadcrumbs: Breadcrumb[] = [];
  public isBreadcrumbClickable = true;
  public isPublicLands = this.chain.chainMarketingIdentifierAbbr === 'pl';
  messageFromHomefield = '';

  @Input()
  public finalLabelOverride: string;

  ngOnInit() {
    this.breadcrumbs = this.buildBreadcrumbs(this.route);
    this.store.select('PERSONAL_INFO').subscribe((personalInfo) => {
      this.isBreadcrumbClickable = !!personalInfo;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['finalLabelOverride'] && !changes['finalLabelOverride'].isFirstChange()) {
      this.breadcrumbs = this.buildBreadcrumbs(this.route);
    }
  }

  buildBreadcrumbs(route: ActivatedRoute): Breadcrumb[] {
    const breadcrumbs = [];

    // Standalone routes store data directly, while module-based routes
    // require accessing the parent route due to an extra routing layer from the module
    const isStandaloneRoute = !!route.routeConfig?.loadComponent;
    let current = isStandaloneRoute ? route : route.parent;

    let breadcrumbsLabels: string[] = [];
    let path = '';

    while (current?.snapshot?.data) {
      if (current.snapshot.data.breadcrumb) {
        breadcrumbsLabels = current.snapshot.data.breadcrumb.split('|').concat(breadcrumbsLabels);
      }
      current = current.parent;
    }

    if (breadcrumbsLabels.includes('Summary')) {
      this.isBreadcrumbClickable = false;
    }

    for (let i = 0; i < breadcrumbsLabels.length; i++) {
      path += `${breadcrumbsLabels[i].replace(/ /g, '')}/`;
      if (i === breadcrumbsLabels.length - 1) {
        breadcrumbs.push({
          name: this.finalLabelOverride ?? breadcrumbsLabels[i],
          url: path,
        });
      } else {
        breadcrumbs.push({ name: breadcrumbsLabels[i], url: path });
      }
    }
    return breadcrumbs;
  }

  trackItem(index: number, item: Breadcrumb) {
    return item.name;
  }

  navigateToRoute(message: string) {
    this.router.navigate([message]);
  }
}
